import { useCallback } from 'react';
import { applicationPaths } from '@core/http/applicationPaths';
import { useApi } from '@core/http/useApi';
import { useAppDispatch } from '@core/store/store';
import { AccessProfile } from '@shared/models/AccessProfile';
import { accountsReducer } from '@core/store/library-stores';

export const useUserDetailsDataSource = () => {
  const dispatch = useAppDispatch();

  const [getUserAccessProfile, userAccessProfile, loading, error] = useApi<AccessProfile>('', 'get');

  const handleGetUserAccessProfile = useCallback(
    (userId: number) => {
      if (userId) {
        const url = applicationPaths.users.getAccessProfile({ id: userId });
        getUserAccessProfile({ additionalOptions: { url } }).catch(() =>
          dispatch(accountsReducer.slice.actions.setUserRole(null))
        );
      }
    },
    [dispatch, getUserAccessProfile]
  );

  return {
    userAccessProfile,
    getUserAccessProfile: handleGetUserAccessProfile,
    loading,
    error,
  };
};
